import { render, staticRenderFns } from "./IconTimesCircle.vue?vue&type=template&id=94ec2dc6&"
import script from "./IconTimesCircle.vue?vue&type=script&lang=js&"
export * from "./IconTimesCircle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports